<template>
  <div>
    <b-form
      data-vv-scope="formulario-documento"
      method="POST"
      enctype="multipart/form-data"
      @submit.prevent="() => editar ? editAdj() : nuevoAdj()"
    >
      <b-row>
        <b-col>
          <b-col lg="12" md="12" sm="12">
            <b-form-group label="Nombre" horizontal>
              <b-form-input
                v-model="selectedDocumentos.descripcion"
                type="text"
                id="nombre"
                name="nombre"
                v-validate="'required'"
                :class="{ 'input-is-invalid': getInputByKey('customName') }"
                @keydown.enter.prevent="onEnterKeyPress"
              ></b-form-input>
              <span v-show="errors.has('formulario-documento.nombre')" class="color-gray-invalid m-1 text-small d-block">{{ errors.first('formulario-documento.nombre') }}</span>
            </b-form-group>
          </b-col>
          <b-col lg="12" md="12" sm="12" v-if="selectedDocumentos.adjuntar">
            <b-form-group label="Adjunto" horizontal class="mb-0" :class="{ 'for-group-input-file': getInputByKey('fileName') }">
              <b-form-file
                accept="application/zip,application/vnd.rar,image/png,image/jpeg,image/jpg,application/pdf,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                @change="getAdjunto"
                placeholder="Seleccione un archivo..."
                name="adjunto"
                ref="adjunto"
                id="adjunto"
                browse-text="Adjuntar"
                drop-placeholder="Arrastre un archivo..."
                @keydown.enter.prevent="onEnterKeyPress"
              ></b-form-file>
            </b-form-group>
            <span v-show="getInputByKey('fileName')" class="color-gray-invalid m-1 mt-0 text-small">{{ 'El nombre del archivo no coincide con el nombre de la empresa.' }}</span>
          </b-col>
          <hr />
          <div class="d-flex justify-content-end">
            <b-button type="submit" variant="primary">
              <i class="fa" :class="{'fa-cloud-upload': !editar, 'fa-pencil': editar }"></i>
              {{ !editar ? 'Adjuntar' : 'Editar' }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import loader from './../../../containers/loader'
import _ from 'lodash'
import Swal from 'sweetalert2'

export default {
  name: 'AdjuntarDocumentosEmpresa',
  props: ['padre', 'empresa', 'editar', 'companies', 'seletedItem'],
  data: function () {
    return {
      invalidNames: [],
    }
  },
  components: {
    loader,
  },
  computed: {
    ...mapState('documentosEmpresa', ['selectedDocumentos']),
  },
  mounted() {
    if(this.editar) this.selectedDocumentos.descripcion = ('text' in this.seletedItem && this.seletedItem) ? this.seletedItem.text : ''
  },
  methods: {
    ...mapActions('documentosEmpresa', ['guardaAdj', 'editaAdj']),
    getAdjunto(event) {
      //Asignamos la imagen a  nuestra data
      let size = event.target.files[0].size
      if (size / 1000 > 6000) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'El archivo no debe pesar más de 6000 kilobytes.',
          showConfirmButton: true,
          timer: 2000,
        })
        this.$refs.adjunto.reset()
        return
      } else {
        this.errors.clear('formulario-documento.adjunto');
        this.selectedDocumentos.adjunto = event.target.files[0]
      }
    },
    async nuevoAdj() {

      this.$validator
        .validateAll('formulario-documento')
        .then(async (result) => {
          if (result) {

            this.invalidNames = []
            let fileName;
            try {
              fileName = this.selectedDocumentos.adjunto.name;
            } catch (e) {
              fileName = null;
            }

            if (!fileName) {
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Documentos',
                text: 'El archivo que intentas procesar esta presentando problemas.',
                showConfirmButton: true
              })
              return false;
            }

            let continueProcess = true;
            [this.selectedDocumentos.descripcion, fileName].map((name, index) => {
              const verifyName = !!this.verifyThatTheFileMatchesTheCompanyName(name);
              if (!verifyName) {
                this.invalidNames.push({
                  key: index === 0 ? 'customName' : 'fileName',
                  value: name
                })
              }
            });

            if (this.invalidNames.length > 0 && typeof this.invalidNames === 'object') {
              await Swal.fire({
                position: 'center',
                icon: 'info',
                title: 'Documentos',
                html: `
                  <div class="text-align-left-alert">
                    <strong class="text-xs">Estos nombres no coinciden con el nombre de la empresa:</strong>
                    <ul class="margin-top-alert text-xs">
                      ${this.invalidNames.map(item => `<li>${item.value}</li>`).join('')}
                    </ul>
                    <span class="text-xs">¿Estas seguro que deseas continuar la acción y subir el archivo.?</span>
                  </div>
                `,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Confirmar y subir archivo',
                cancelButtonText: 'Cancelar'
              }).then(result => {
                if(!result.isConfirmed) continueProcess = false;
              });
            }

            if (!continueProcess) return false;

            const formData = new FormData()
            formData.append('adjunto', this.selectedDocumentos.adjunto)

            this.selectedDocumentos.padre_id = this.padre
            this.selectedDocumentos.empresaId = this.empresa

            await this.guardaAdj(formData)
            this.resetForm()
            this.$refs.adjunto.reset()
            this.$attrs.modalAttachmentRef.hide()
          }
        })
    },
    async editAdj() {
      this.$validator
        .validateAll('formulario-documento')
        .then(async (result) => {
          if (result) {
            const formData = new FormData()
            formData.append('adjunto', this.selectedDocumentos.adjunto)

            this.selectedDocumentos.padre_id = this.padre
            this.selectedDocumentos.empresaId = this.empresa

            await this.editaAdj(formData)
            this.resetForm()
            this.$emit('closeModalCrear')
            this.$attrs.modalAttachmentRef.hide()
          }
        })
    },
    /**
     * Verificar que el nombre del archivo tenga coincidencias con el nombre de la empresa.
     * @author Fernando Claros
     */
    verifyThatTheFileMatchesTheCompanyName(fileName) {
      try {

         // Dividir ambas cadenas en palabras
        fileName = this.removeSpecialCharacters(fileName).split(' ');
        const companyName = this.removeSpecialCharacters(this.getCompanyName()).split(' ');

        // Iterar a través de las palabras en "Nombre de la empresa" y verificar si alguna está en "Nombre del archivo subido"
        const matchesFound = [];
        for (let i = 0; i < companyName.length; i++) {
          if (fileName.includes(companyName[i]) && companyName[i].length >= 2) {
            matchesFound.push(companyName[i]);
            continue; // Si se encuentra una coincidencia, puedes salir del bucle
          }
        }

        if (matchesFound.length > 0) return true;
        return false;

      } catch (e) {
        return false;
      }
    },
    /**
     * Elimina caracteres especiales y convierte a minúsculas
     * @param {*} cadena
     * @author Fernando Claros
     */
    removeSpecialCharacters(cadena = '') {
      if (typeof cadena !== 'string') return '';
      return cadena.replace(/[^\w]/gi, ' ').toLowerCase();
    },
    /**
     * Obtener el nombre de la empresa seleccionada.
     * @author Fernando Claros
     */
    getCompanyName() {
      return this.companies.find(company => company.id == this.empresa).nombre || ""
    },
    /**
     * Permite saber si el input tiene validaciones personalizadas fallidas.
     * @param String key
     * @author Fernando Claros
     */
    getInputByKey(key) {
      return this.invalidNames.find(item => item.key === key) ? true : false
    },
    /**
     * Desactivar el comportamiento predeterminado del evento "Enter" en los campos de entrada Input.
     * @author Fernando Claros
     */
    onEnterKeyPress(event) {
      // Verificar si la tecla presionada es "Enter" (código 13)
      if (event.keyCode === 13) {
        // Prevenir el comportamiento predeterminado del "Enter"
        event.preventDefault();
      }
    },
    resetForm: function () {
      this.selectedDocumentos.descripcion = null
      this.selectedDocumentos.adjunto = null
      this.selectedDocumentos.activo = null
      this.selectedDocumentos.nodeActiveId = null
    },
  },
  watch: {},
}
</script>

<style>
  .text-align-left-alert{
    text-align: left !important;
  }
  .margin-top-alert{
    margin: 10px 0;
  }
  .text-xs{
    font-size: 15px !important;
  }
  .text-small{
    font-size: 13px !important;
  }
  .for-group-input-file div,
  .input-is-invalid{
    border: 1.5px solid #f25050 !important;
    border-radius: 6px;
  }
  .color-gray-invalid{
    color: #818181 !important;
  }
  .for-group-input-file div:nth-child(1){
    border: 0 !important;
    border-radius: 6px;
  }
</style>
